import { render, staticRenderFns } from "./add-care-royalty-free-popup.vue?vue&type=template&id=41747fe7"
import script from "./add-care-royalty-free-popup.vue?vue&type=script&lang=js"
export * from "./add-care-royalty-free-popup.vue?vue&type=script&lang=js"
import style0 from "./add-care-royalty-free-popup.vue?vue&type=style&index=0&id=41747fe7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports